export default function () {
  const { body } = document;

  if (body.classList.contains('home') || body.classList.contains('page-template-tpl-about')) {
    return;
  }

  const blocksChange = document.querySelectorAll('[data-color-tone]');
  const sections = document.querySelectorAll('[data-header-mode]:not(.block-sticky)');

  const blockSticky = document.querySelector('.block-sticky');
  let modes = [];

  const setModes = () => {
    modes = [];

    if (blockSticky) {
      modes[0] = blockSticky.dataset.headerMode;
    }

    sections.forEach((e) => {
      modes[Math.round(e.getBoundingClientRect().top + window.scrollY)] = e.dataset.headerMode;
    });
  };

  const changeColors = () => {
    blocksChange.forEach((element) => {
      const elementTop = element.getBoundingClientRect().top;
      const scroll = window.scrollY + elementTop + element.offsetHeight / 2;

      modes.forEach((e, i) => {
        if (scroll > i) {
          // eslint-disable-next-line no-param-reassign
          element.dataset.colorTone = e;
        }
      });
    });
  };

  setModes();
  changeColors();

  document.addEventListener('headerAnimationDone', () => {
    setModes();
    changeColors();
  });
  window.addEventListener('resize', () => {
    setModes();
    changeColors();
  });
  document.addEventListener('scroll', changeColors);
}
